
<section class="error">
    <div class="error-content">
        <div class="left-roboto"><img src="/assets/images/invalidLink-error.png" alt="error-img" class="img-fluid"></div>
        <div class="middle-content">
            <h1>{{errorMessage}}</h1>
            <a class="btn" onClick="javascript:history.go(-1)">  <i class="fa fa-angle-left"></i>&nbsp;Back</a>
        </div>
        <div class="right-roboto">
            <img src="/assets/images/robot.png" alt="error-img" class="img-fluid robot">
            <img src="/assets/images/ballon.png" alt="error-img" class="img-fluid ballon">
            <img src="/assets/images/ballon-1.png" alt="error-img" class="img-fluid ballon-1">
        </div>
    </div>
    </section>
